import { createAction } from '@reduxjs/toolkit';

export const UPDATE_ORDER_ACTION_TYPE = 'saga/updateOrder';
export const updateOrderAction = createAction(UPDATE_ORDER_ACTION_TYPE);
